import { render, staticRenderFns } from "./SpinnerGrow.vue?vue&type=template&id=1ac57905&"
import script from "./SpinnerGrow.vue?vue&type=script&lang=js&"
export * from "./SpinnerGrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports